<template>
    <div class="jianyezhengfu">
        <div class="content">
            <p class="title">建邺区人民政府</p>
            <p class="con1 "><span class="point"></span>个性化的数字化移动办公平台，为消防正规化信息化建设提供支撑</p>
            <p class="con1-1">钉钉拥有强大的门户平台、在线协同、远程办公的能力，疫情期间，帮助多个消防支队实现了远程办公，在线指挥作战，在线学习，在线心理关怀疏导，通过钉钉门户和集成的方案实现了更加安全的，个性化的数字化移动办公平台，为消防正规化中信息化建设提供支撑。</p> 
            <img class="img-jianye" src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Farti.2boss.cn%2FueImages%2F20180712%2F1531361449456020.jpeg&refer=http%3A%2F%2Farti.2boss.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1658648991&t=98281370cbe2a36c08ecd790f4806c04" alt="" />  
            <p class="con1 "><span class="point"></span>建邺区人民政府</p>
            <p class="tag">政府 | 中国-江苏-南京 | 云枢</p>
            <p class="con1-1">使用目的：为政府各部门之间处理政务，以及OA审批办公提供便利，助力政府单位完成数字化转型。</p> 

            <p class="con1 top"><span class="point"></span>客户痛点</p>
            <ul class="ul-list">
                <li><span class="point2"></span>没有一个集沟通与协同为一体的移动化平台。</li>
                <li><span class="point2"></span>原有的信息化系统多在PC端，使用不便捷，各系统独立，形成数据孤岛。</li>
                <li><span class="point2"></span>对于系统的安全性要求高，同时对于组织人员实时状态了解比较高。</li>
                <li><span class="point2"></span>组织分散，无法统一进行管控。沟通平台分散，无统一平台。</li>
            </ul>

        </div>
    </div>
</template>
        
<script>
export default {
   
}
</script>
<style lang='less' scoped>
.jianyezhengfu{
    width: 100%;
    height: 100%;
    text-align: left;
    list-style: disc!important;
    .content{
        width: 1140px;
        margin: auto;
        padding-top: 40px;
        padding-bottom: 40px;
        .title{
            text-align: center;
            font-size: 38px;
            color: #000;
            margin-bottom: 30px;
        }
        .con1{
            font-size: 24px;
            margin-bottom: 10px;
        }
        .con1-1{
            color:#999999;
            font-size: 18px;
        }
        .point {
            display: inline-block;
            width: 12px;      
            height: 12px;     
            border: 1px solid #ff6c04;      
            border-radius: 50%;      
            background-color: #ff6c04;
            margin-right: 10px;
        }
        .img-jianye{
            width: 100%;
            height: 695px;
            margin-top: 40px;
        }
        .tag{
            margin-bottom: 15px;
        }
        .top{
            margin-top: 50px;
        }
        .point2{
            display: inline-block;
            width: 4px;      
            height: 4px;  
            margin-top: 4px;   
            border: 1px solid #000;      
            border-radius: 50%;      
            background-color: #000;
            margin-right: 10px;
        }
        .ul-list{
            li{
                display: flex;
                align-items: center;
                margin-bottom: 15px;
            }
        }
        
        
    }
}
</style>